/* eslint-disable react/jsx-handler-names */
import React from 'react';
import navStyles from '../index.module.less';
import styles from './index.module.less';
import classNames from 'classnames';
import type * as I from '@/interface/product';
import { getNavProductList } from '@/api/client/product';
import { ReoIcon } from '@reolink-web/components.basic';
import Loading from '@/components/Loading';
import CompProductsDropdown from './CompProductsDropdown';
import { HeaderContext } from '@/components/ReolinkHeader/common';

interface IProductNavItemProps {
    isShowSubMenu?: boolean;
    onTitleClick?: () => void;
}

const CompProductNavItem: React.FC<IProductNavItemProps> = React.memo((props) => {
    const { getTextByKey, setIsShowSearch, lang } = React.useContext(HeaderContext);

    const [isLoading, setIsLoading] = React.useState(true);
    const [navProductList, setNavProductList] = React.useState<I.INavProductCategoryItem[]>([]);

    const fetchNavProductList = React.useRef(async (lang: string) => {
        setIsLoading(true);
        try {
            const res = await getNavProductList({
                lang: lang,
            });
            setNavProductList(res);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
        finally {
            setIsLoading(false);
        }
    });

    React.useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchNavProductList.current(lang);
    }, [lang]);

    return (
        <>
            <li className={ classNames(classNames(styles['search-product']), classNames(styles['search-product-m'])) }>
                <input
                    className={ styles['search-product-input'] }
                    placeholder={ getTextByKey('search-products') }
                    onClick={ () => {
                        setIsShowSearch?.(true);
                    } }
                />
            </li>
            <li
                className={ classNames(navStyles['nav-item'], navStyles['nav-with-menus'], styles['nav-item-products'], {
                    [navStyles['show-sub-menu']]: props.isShowSubMenu,
                }) }
            >
                <a
                    className={ navStyles['nav-item-title'] }
                    onClick={ props.onTitleClick }>
                    <span className={ navStyles['nav-item-title-text'] }>{getTextByKey('nav-products')}</span>
                    <ReoIcon
                        name={ props.isShowSubMenu ? 'icon-icon_cross2' : 'icon-icon_plus' }
                        className={ navStyles['nav-item-title-icon'] }
                    />
                </a>
                <div className={ styles['products-dropdown-content'] }>
                    {isLoading ? (
                        <Loading
                            type={ 'partial' }
                            className={ styles['products-loading'] } />
                    ) : (
                        <CompProductsDropdown navProductList={ navProductList } />
                    )}
                </div>
            </li>
        </>
    );
});
export default CompProductNavItem;
